import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Glyphicon, Button } from 'react-bootstrap';
import actions from '../../../../constants/actions';

class IconsRowTable extends PureComponent {
  static propTypes = {
    icons: PropTypes.array.isRequired,
  };
  
  static defaultProps = {
    icons: [],
  };

  onPressAction = (id, name, action) => {
    this.props.showModalHandle(id, name, action);
  }

  render () {
    const {
      icons,
    } = this.props;

    return (
      <Table className="links-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Icon</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            icons.map((icon, index) => (
              <tr key={`icon-${index}`}>
                <td>{icon.name} <span style={{ color: 'green' }}>{ (icon.default_to_show) ? 'default' : '' }</span></td>
                <td>
                  <img
                    alt={icon.name}
                    src={icon.icon_path}
                    style={{ width: '20px' }}
                  />
                </td>
                <td>
                  <Button
                    style={{ border: 'none' }}
                    onClick={() => this.onPressAction(icon.id, icon.name, actions.edit)}
                  >
                    <Glyphicon glyph="pencil" />
                  </Button>
                  <Button
                    style={{ border: 'none' }}
                    onClick={() => this.onPressAction(icon.id, icon.name, actions.delete)}
                  >
                    <Glyphicon glyph="trash" />
                  </Button>
                </td>
              </tr>
            ))
          }
        </tbody>
      </Table>
    );
  }
}

export default IconsRowTable;


// WEBPACK FOOTER //
// ./src/app/screens/icons/iconsList/iconsRowTable.js